export default "__VITE_ASSET__DGHxe34E__"